import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Overview from "@/pages/home/components/Overview";
import DramaSection from "@/pages/home/components/DramaSection";
import NovelSection from "@/pages/home/components/NovelSection";
import MovieSection from "@/pages/home/components/MovieSection";
import UncutSection from "@/pages/home/components/UncutSection";
import RecommendSection from "@/pages/home/components/RecommendSection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <DramaSection />
        <NovelSection />
        <MovieSection />
        <UncutSection />
        <RecommendSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}